import styled from "styled-components";

export const LogoImageDefaultBox = styled.img<{isVip?: boolean; width?: number; height?: number;}>`
    display: block;
    margin: 0 auto;
    height: 4.2rem;
    width: auto;
    
    /* Explicit dimensions for CLS prevention */
    ${props => props.width && `width: ${props.width}px;`}
    ${props => props.height && `height: ${props.height}px;`}

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        height: 3rem;
    }
`;